import { Column } from '@devexpress/dx-react-grid';
import { formatDateTime } from 'utils/helpers';

export const WP_SITE_CONNECTION_REPORT = 'WP Site Connections';

export const WP_SITE_CONNECTIONS_REPORT_MESSAGE =
  `This report shows all active repairers that are currently connected to this work provider. 
  The data shown is based on the Data Access Profile assigned to your account. As a result, you may not see all repairers if your profile does not have permission to view them.`;

export const WP_SITE_CONNECTION_REPORT_GRID_TITLE = 'wpSiteConnectionsReport';

export const columns: Column[] = [
  { name: 'repairerGroup', title: 'Group' },
  { name: 'siteCode', title: 'Site Code' },
  { name: 'capsCodes', title: 'CAPS Codes' },
  { name: 'name', title: 'Name' },
  { name: 'address', title: 'Address' },
  { name: 'postcode', title: 'Postcode' },
  { name: 'systemType', title: 'System Type' },
  { name: 'connectionDetails', title: 'Connection Details' },
];

export const reportHeaderTagLine = `Report produced on ${formatDateTime(new Date())}`;

// TODO: remove after testing 
export const mockedReportData = [
  {
    systemType: "AUTOSOFT",
    siteCode: "0511",
    address: "24 iffracomb avenue",
    postcode: "rg41 1np2",
    name: "11May-Repairer-Test",
    repairerGroup: "TEST-GROUP-11MAY",
    connectionDetails: "Connected CAPS",
    capsCodes: "N.A."
  },
  {
    systemType: "AUTOSOFT",
    siteCode: "0518",
    address: "26 court road",
    postcode: "rgi 8aq",
    name: "May18-Rep",
    repairerGroup: "REPGROUP",
    connectionDetails: "Connected STD",
    capsCodes: "N.A."
  },
  {
    systemType: "AUTOSOFT",
    siteCode: "0522",
    address: "hyd",
    postcode: "rg73ty",
    name: "Reptest22may",
    repairerGroup: "FIXAUTO",
    connectionDetails: "Connected CAPS",
    capsCodes: "N.A."
  },
  {
    systemType: "AUTOSOFT",
    siteCode: "053123",
    address: "23fderf",
    postcode: "rg57yg",
    name: "NewMay31Rep",
    repairerGroup: "INDEPENDENT",
    connectionDetails: "Connected CAPS",
    capsCodes: "test_caps"
  },
  {
    systemType: "AUTOSOFT",
    siteCode: "0612",
    address: "1 Hawkedon way",
    postcode: "rg6 4bh",
    name: "May12-NewRepairer",
    repairerGroup: "NEWRGROUP",
    connectionDetails: "Connected NARG",
    capsCodes: "KVS002"
  },
  {
    systemType: "AUTOSOFT",
    siteCode: "1112302",
    address: "123, test",
    postcode: "380051",
    name: "Test repairer2 1Nov2023",
    repairerGroup: "TEST",
    connectionDetails: "Connected STD",
    capsCodes: "N.A."
  },
  {
    systemType: "AUTOSOFT",
    siteCode: "12345",
    address: "test street",
    postcode: "12-345",
    name: "Ewelina Test",
    repairerGroup: "TEST",
    connectionDetails: "Connected NARG (12345)",
    capsCodes: "N.A."
  },
  {
    systemType: "AUTOSOFT",
    siteCode: "2205",
    address: "liverpol",
    postcode: "rg57yg",
    name: "TestRep22May",
    repairerGroup: "FIXAUTO",
    connectionDetails: "Connected CAPS",
    capsCodes: "rep_caps"
  },
]